import { render, staticRenderFns } from "./FirstTime.vue?vue&type=template&id=724cb048&scoped=true"
import script from "./FirstTime.vue?vue&type=script&lang=js"
export * from "./FirstTime.vue?vue&type=script&lang=js"
import style0 from "./FirstTime.vue?vue&type=style&index=0&id=724cb048&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724cb048",
  null
  
)

export default component.exports